export default "__VITE_ASSET__d0704033__"